import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-tmams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-tmams.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { MapService } from "../../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { AlertType } from "../../../../../shared/models/alert";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../../app.config";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import Query from "@arcgis/core/rest/support/Query";
import { CreateApplicationLocationTmamsConstants } from "./create-application-location-tmams.constants";
import { debounceTime } from "rxjs";
import { PopUpComponent } from "../../../../../shared/components/pop-up/pop-up.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { take, takeUntil } from "rxjs/operators";
import { AutoUnsub } from "../../../../../shared/decorators/autounsub.decorator";
import { SimulationUtils } from "../../../../../shared/utils/simulation-utils";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
let CreateApplicationLocationTmamsComponent = class CreateApplicationLocationTmamsComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    recipientListService;
    appController;
    modalService;
    mapService;
    requestStatusService;
    changeDetectorRefs;
    active;
    propertiesForm;
    descriptionLabel1 = CreateApplicationLocationTmamsConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationTmamsConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationTmamsConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = CreateApplicationLocationTmamsConstants.DESCRIPTION_LABEL_4;
    validationMessages = CreateApplicationLocationTmamsConstants.VALIDATION_MESSAGES;
    erfNoControl = CreateApplicationLocationTmamsConstants.ERF_NO_CONTROL;
    subdivisionControl = CreateApplicationLocationTmamsConstants.SUBDIVISION_CONTROL;
    allotmentControl = CreateApplicationLocationTmamsConstants.ALLOTMENT_CONTROL;
    farmNoControl = CreateApplicationLocationTmamsConstants.FARM_NO_CONTROL;
    sgCodeControl = CreateApplicationLocationTmamsConstants.SG_CODE_CONTROL;
    addressControl = CreateApplicationLocationTmamsConstants.ADDRESS_CONTROL;
    ownerControl = CreateApplicationLocationTmamsConstants.OWNER_CONTROL;
    erfNoTextPlaceHolder = CreateApplicationLocationTmamsConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = CreateApplicationLocationTmamsConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = CreateApplicationLocationTmamsConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = CreateApplicationLocationTmamsConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = CreateApplicationLocationTmamsConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = CreateApplicationLocationTmamsConstants.ADDRESS_TEXT_PLACEHOLDER;
    ownerLabel = CreateApplicationLocationTmamsConstants.OWNER_LABEL;
    copyApplicantToOwnerLabel = CreateApplicationLocationTmamsConstants.COPY_APPLICANT_TO_OWNER_LABEL;
    removePropertyLabel = CreateApplicationLocationTmamsConstants.REMOVE_PROPERTY_LABEL;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerGroups = [];
    ownerListLabel = "Owner";
    mapComponent;
    isMapLoaded = false;
    modalOptions = CreateApplicationLocationTmamsConstants.MODAL_OPTION;
    selectedPropertySubscription;
    getTrueCentroidSubscription;
    clearLayerGraphicsSubjectSubscription;
    constructor(createApplicationService, aflaModuleStrategyService, recipientListService, appController, modalService, mapService, requestStatusService, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.recipientListService = recipientListService;
        this.appController = appController;
        this.modalService = modalService;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        this.subscribeToProperty();
        if (this.createApplicationService.propertyData) {
            this.loadExistingProperty(this.createApplicationService.propertyData);
            this.createApplicationService.propertyData = null;
        }
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
    }
    loadMetadata(stepMeta) {
        try {
            if (this.appController.moduleSimulateMode) {
                this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientFilterGroupObjects);
            }
            else {
                this.ownerGroups = stepMeta.ownerGroup;
                if (this.ownerGroups[0].hasOwnProperty("requiredFields") && this.ownerGroups[0].requiredFields !== null) {
                    this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(this.ownerGroups);
                }
            }
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    getProperties() {
        return this.propertiesForm.get("properties");
    }
    getZones(propertyIndex) {
        return this.getProperties().controls[propertyIndex].get("zones");
    }
    updateRequiredFields(propertyIndex) {
        const propertyControl = this.getProperties().controls[propertyIndex];
        const erfNoControl = propertyControl.get(this.erfNoControl);
        const farmNoControl = propertyControl.get(this.farmNoControl);
        const subdivisionControl = propertyControl.get(this.subdivisionControl);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.clearValidators();
            subdivisionControl.clearValidators();
            farmNoControl.setValue("");
            subdivisionControl.setValue("");
            farmNoControl.disable();
            subdivisionControl.disable();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") ||
            (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.clearValidators();
            erfNoControl.setValue("");
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
        }
        else {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            subdivisionControl.enable();
            erfNoControl.markAsUntouched();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        const sgCodeControl = propertyControl.get(this.sgCodeControl);
        if (sgCodeControl.value !== null && sgCodeControl.value !== undefined && sgCodeControl.value !== "") {
            sgCodeControl.disable();
        }
        else {
            sgCodeControl.enable();
        }
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        subdivisionControl.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    onBtnCopyApplicantToOwnerClicked(propertyIndex) {
        const applicant = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
        const ownersFormControl = this.getProperties().controls[propertyIndex].get("owners");
        this.recipientListService.addRecipient(applicant, true, ownersFormControl, true);
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        const previoursActiveIndex = this.active;
        this.getProperties().removeAt(propertyIndex);
        this.changeDetectorRefs.detectChanges();
        if (previoursActiveIndex === propertyIndex && propertyIndex > 0) {
            this.active = propertyIndex - 1;
        }
        else if (previoursActiveIndex > propertyIndex) {
            this.active = previoursActiveIndex - 1;
        }
    }
    hasControlValidator(control) {
        if (control.validator) {
            const validator = control.validator({});
            if (validator && validator.required) {
                return true;
            }
        }
    }
    setNumberToDecimal(control, event) {
        //  sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        control.setValue(decimalValue);
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("propertiesForm");
        this.propertiesForm = form;
    }
    loadExistingProperty(property) {
        this.setPropertyData(property, property.geometry);
    }
    setPropertyData(propertyObject, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const sgCode = this.propertyDataAlternateColumnName(propertyObject, "SgCode", "sgcode");
        let found = false;
        this.getProperties().controls.forEach(item => {
            const check = item.get("sgCode").value;
            if (check === sgCode) {
                found = true;
                this.appController.showMessage(CreateApplicationLocationTmamsConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }
        });
        if (!found) {
            const newProperty = new FormGroup({
                erfNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfNo", "erfno"), [Validators.required]),
                subdivision: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "PtnNum", "ptnnum"), [Validators.required]),
                allotment: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Allotment", "allotment"), [Validators.required]),
                farmNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "FarmNo", "farmno"), [Validators.required]),
                sgCode: new FormControl(sgCode, [Validators.required]),
                address: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Address", "address"), [Validators.required]),
                geometry: new FormControl(geometry),
                centroid: new FormControl(null, [Validators.required]),
                zones: new FormArray([], [Validators.min(1)]),
                owners: new FormControl(null, [Validators.required])
            });
            const proxyUrl = ApiProxyConstants.URL;
            const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
            const url = `${proxyUrl}?${gpToolUrl}`;
            const formData = new FormData();
            formData.append("f", "json");
            formData.append("geometryJSON", JSON.stringify(geometry));
            this.getTrueCentroidSubscription = this.createApplicationService.getTrueCentroid(url, formData)
                .pipe(takeUntil(this._destroy$), take(1)).subscribe({
                next: (trueCentroidResponse) => {
                    newProperty.get("centroid").setValue(trueCentroidResponse.results[0].value);
                    this.getPropertyOwners(sgCode, newProperty);
                },
                error: (error) => {
                    this.requestStatusService.removeBusySpinner("GetPropertyDate");
                    this.appController.handleServerErrorMessage(CreateApplicationLocationTmamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                }
            });
        }
    }
    getPropertyOwners(sgCode, newProperty) {
        const ownerLayerObj = this.mapService.userMaps.find(a => a.selectionLayerType === "Property owner");
        if (ownerLayerObj !== undefined && ownerLayerObj !== null) {
            const ownerLayer = ownerLayerObj.layer;
            const ownerQuery = new Query();
            ownerQuery.where = `SgCode = '${sgCode}'`;
            ownerQuery.returnGeometry = false;
            ownerQuery.outFields = ["*"];
            ownerLayer.queryFeatures(ownerQuery).then((ownerFeatureSet) => {
                // Make sure the grave centroid is within one cemetery boundary
                const ownersControl = newProperty.get("owners");
                const owners = [];
                if (ownerFeatureSet.features.length > 0) {
                    ownerFeatureSet.features.forEach(item => {
                        try {
                            const newOwner = {
                                id: 0,
                                name: item.attributes.Name ? item.attributes.Name : item.attributes.name,
                                surname: item.attributes.Surname ? item.attributes.Surname : item.attributes.surname,
                                telephone: item.attributes.Telephone ? item.attributes.Telephone : item.attributes.telephone,
                                email: item.attributes.Email ? item.attributes.Email : item.attributes.email,
                                defaultCommunicationMethod: item.attributes.DefaultCommunicationMethod ? item.attributes.DefaultCommunicationMethod : item.attributes.defaultcommunicationmethod,
                                postalAddress: item.attributes.PostalAddress ? item.attributes.PostalAddress : item.attributes.postaladdress,
                                designation: item.attributes.Designation ? item.attributes.Designation : item.attributes.designation,
                                organisation: item.attributes.Organisation ? item.attributes.Organisation : item.attributes.organisation,
                                clientVatNumber: item.attributes.ClientVatNumber ? item.attributes.ClientVatNumber : item.attributes.clientvatnumber,
                                streetAddress: item.attributes.StreetAddress ? item.attributes.StreetAddress : item.attributes.streetaddress,
                                homePhone: item.attributes.Homephone ? item.attributes.Homephone : item.attributes.homephone,
                                idNumber: item.attributes.IDNumber ? item.attributes.IDNumber : item.attributes.idnumber,
                                organisationRegistrationNumber: item.attributes.OrganisationRegistrationNumber ? item.attributes.OrganisationRegistrationNumber : item.attributes.organisationregistrationnumber,
                                representative: item.attributes.Representative ? item.attributes.Representative : item.attributes.representative,
                                fax: item.attributes.Fax ? item.attributes.Fax : item.attributes.fax,
                                cellphone: item.attributes.Cellphone ? item.attributes.Cellphone : item.attributes.cellphone,
                                streetSuburb: item.attributes.StreetSuburb ? item.attributes.StreetSuburb : item.attributes.streetsuburb,
                                streetCity: item.attributes.StreetCity ? item.attributes.StreetCity : item.attributes.streetcity,
                                streetProvince: item.attributes.StreetProvince ? item.attributes.StreetProvince : item.attributes.streetprovince,
                                streetCode: item.attributes.StreetCode ? item.attributes.StreetCode : item.attributes.streetcode,
                                postalSuburb: item.attributes.PostalSuburb ? item.attributes.PostalSuburb : item.attributes.postalsuburb,
                                postalCity: item.attributes.PostalCity ? item.attributes.PostalCity : item.attributes.postalcity,
                                postalProvince: item.attributes.PostalProvince ? item.attributes.PostalProvince : item.attributes.postalprovince,
                                postalCode: item.attributes.PostalCode ? item.attributes.PostalCode : item.attributes.postalcode,
                                postalCountry: item.attributes.PostalCountry ? item.attributes.PostalCountry : item.attributes.postalcountry,
                                streetCountry: item.attributes.StreetCountry ? item.attributes.StreetCountry : item.attributes.streetcountry,
                                professionalBody: item.attributes.ProfessionalBody ? item.attributes.ProfessionalBody : item.attributes.professionalbody,
                                professionalBodyRegNum: item.attributes.ProfessionalBodyRegistrationNumber ? item.attributes.ProfessionalBodyRegistrationNumber : item.attributes.professionalbodyregistrationumber,
                                groups: []
                            };
                            owners.push(newOwner);
                        }
                        catch {
                            this.appController.showMessage(CreateApplicationLocationTmamsConstants.INVALID_OWNER_ATTRIBUTE, AlertType.Error);
                        }
                    });
                }
                const propertyControl = this.getProperties();
                const propertyIndex = propertyControl.length;
                propertyControl.push(newProperty);
                this.active = propertyControl.length - 1;
                this.updateRequiredFields(propertyIndex);
                this.changeDetectorRefs.detectChanges();
                if (owners.length > 0) {
                    this.recipientListService.setRecipients(owners, true, ownersControl);
                }
                this.changeDetectorRefs.detectChanges();
                this.syncMapGeometries();
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }, (error) => {
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
                this.appController.showMessage(error.message, AlertType.Error);
            });
        }
        else {
            const propertyControl = this.getProperties();
            const propertyIndex = propertyControl.length;
            propertyControl.push(newProperty);
            this.active = propertyControl.length - 1;
            this.updateRequiredFields(propertyIndex);
            this.changeDetectorRefs.detectChanges();
            this.syncMapGeometries();
            this.requestStatusService.removeBusySpinner("GetPropertyDate");
        }
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Training module graphics", true);
        }
    }
    subscribeToProperty() {
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(1000)).subscribe(property => {
            if (property !== null) {
                this.checkIfPropertyIsAlreadyLoaded(property);
                // this.setPropertyData(property.attributes, property.geometry);
            }
        });
    }
    checkIfPropertyIsAlreadyLoaded(property) {
        const title = "Replace property";
        const contentMessage = "An application can only have 1 property. Do you want to replace the current property?";
        const propertyControl = this.getProperties();
        if (propertyControl && propertyControl.length > 0) {
            const dialogRef = this.modalService.open(PopUpComponent, this.modalOptions);
            dialogRef.componentInstance.title = title;
            dialogRef.componentInstance.contentMessage = contentMessage;
            dialogRef.componentInstance.data = true;
            dialogRef.result.then((replaceData) => {
                if (replaceData) {
                    this.getProperties().clear();
                    this.mapComponent.clearGraphics("Training module graphics");
                    this.setPropertyData(property.attributes, property.geometry);
                }
            });
        }
        else {
            this.setPropertyData(property.attributes, property.geometry);
        }
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: RecipientListService },
        { type: AppControllerService },
        { type: NgbModal },
        { type: MapService },
        { type: RequestStatusService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationLocationTmamsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-location-tmams",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], CreateApplicationLocationTmamsComponent);
export { CreateApplicationLocationTmamsComponent };
